<!--通过消缺新建工单(直接复制创建工单的，有一些代码是无用的)-->
<template>
	<div class="orderBody">
		<div class="leftPart">
			<p>分组</p>
			  <el-select v-model="nowOrderGroupnew" placeholder="请选择" @change="pickerOrderGroup_fn">
				<el-option	v-for="item in orderGroupList"	:key="item.id"	:label="item.name"	:value="item.id">	</el-option>
			</el-select>
			<p class="title-top">开始时间</p>
			 <el-date-picker v-model="orderStartTime"  type="datetime"  placeholder="选择日期时间"  align="right"  :picker-options="pickerOptions"> </el-date-picker>
			<p class="title-top">截止时间</p>
				 <el-date-picker v-model="orderEndTime"  type="datetime"  placeholder="选择日期时间"  align="right"  :picker-options="pickerOptions"> </el-date-picker>
			<p class="title-top">抄送人</p>
			<p class="pickerText" @click="addUsers" :title="nowParticipantsNames">{{nowParticipantsNames}}</p>
			<p class="title-top">发布方式</p>
			<div class="cycleType">
				 <el-radio v-model="radio" label="1">手动</el-radio>
				
			</div>
			 
			
		</div>
		<div class="rightPart custom-scrollbar" style="overflow-x: hidden;">

			<div class="right-top">
				<div class="flex-left">
					<div class="top-mome"><span>工单名称（必填）：</span><el-input v-model="orderTitle" placeholder="请输入工单名称"></el-input></div>
					<div class="top-mome"><span>工单描述：</span><el-input v-model="orderContent" placeholder="请输入工单描述"   type="textarea" :rows="1"></el-input></div>
				</div>
				<div class="btns">
					<el-button type="primary" size="small" @click="isCycle?upload('CycleOrder',cycleTime):upload('Order')">发布工单</el-button>
				<el-button type="primary" size="small" plain @click="returnToList">返回</el-button>
				</div>

			</div>
			<createNode ref="createNodeBean" :nowDefecList='nowDefecList' :isImport="isImport" :nowOrderGroup="nowOrderGroup" :nowFlow="nowFlow" :orderStartTime='orderStartTime' :orderEndTime="orderEndTime" @pickerWorkFlow="pickerWorkFlow"></createNode>
		</div>
	</div>
</template>

<script type="text/javascript">
	import createNode from '@/page/order/createOrder/defectCreateNode.vue'
	export default {
		components: {
			createNode,
		},
		props: {
			nowDefecList: {
				type: Object
				},
		},
		data() {
			return {
				radio:"1",
			    pickerOptions: {
					
          shortcuts: [{
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date());
            }
          }, {
            text: '昨天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', date);
            }
          }, {
            text: '一周前',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date);
            }
          }]
                 },
				  isImport:true,
				nowOrderGroup: undefined,
				nowOrderGroupnew:"",
				showSaveToDemo: false,
				nowInputFlow: undefined,
				nowInputDemo: undefined,
				participants: [],
				orderTitle: "",
				orderContent: "",
				orderStartTime: new Date(new Date().getTime()),
				orderEndTime: new Date(new Date().getTime() + 24 * 60 * 60 * 1000 + 30 * 60 * 1000),
				nowFlow: {
					name: '默认工作流',
					next: []
				},
				isCycle: false,
				cycleTime: 'day',
				groupId:"",
				// orderGroupList:[]
			}
		},
		created() {
			debugPage = this
		},
		mounted() {

            // this.$store.orderGroupStore.commit('getOrderGroupTree')
            // this.orderGroupList = this.$store.orderGroupStore.state.orderGroupTree
			// console.log("获取列表",this.orderGroupList );
			// if(this.orderGroupList.length != 0){
			// 		this.orderGroupList.shift()
			// 	}
			if(this.orderGroupList != undefined) {
				this.nowOrderGroup = this.orderGroupList[0]
				this.nowOrderGroupnew = this.orderGroupList[0].id
			}
			//从缓存中判断是否是从事件界面跳转过来的
			this.isFromEvent()
		},
		computed: {
			orderGroupList() {
				// var data = this.$store.orderGroupStore.state.orderGroupTree
				var data = copy(this.$store.orderGroupStore.getters.getOrderGroupTree)
				if(data.length != 0){
					data.shift()
				}
				return data
			},
			priorityList() {
				return this.$store.orderStore.state.priorityList
			},
			cycleTypeList() {
				return this.$store.orderStore.state.cycleTypeList
			},
			userTree() {
				// console.log("树形",this.$store.userStore.getters.getUnitUserTree);
				return this.$store.userStore.getters.getUnitUserTree
			},
			deleteIco() {
				return this.$store.resourcesStore.getters.getResourcesByName('/wedoButton/delete.png')
			},
			getFlowList() {
				return this.$store.workFlowStore.getters.getFlowList
			},
			getDemoList() {
				//模板列表
				return this.$store.orderStore.getters.getOrderTemplateList('NotStarted')
			},
			nowFlowTree() {
				if(this.nowInputFlow == undefined) {
					return undefined
				}
				return this.$store.workFlowStore.getters.getFlowTreeByFlowId(this.nowInputFlow.flowId)
			},
			nowParticipantsNames() {
				if(isempty(this.participants)) {
					return '点击选择抄送人'
				}
				return this.participants.map(item => item.username).join(' , ')
			},
			nowOrderGroupName() {
				if(this.nowOrderGroup == undefined) {
					return '选择分组'
				}
				return this.nowOrderGroup.name
			},
			flowTree() {
				return [{
					name: '私有工作流',
					id: '1',
					next: this.getFlowList(1)
				}, {
					name: '公有工作流',
					id: '0',
					next: this.getFlowList(0)
				}]
			},
			cycleTimeList() {
				//计算出的下两次运行时间
				var start = new Date(this.orderStartTime.getTime())
				var list = []
				list.push(start.formatByTime('-'))
				for(var i = 0; i < 3; i++) {
					switch(this.cycleTime) {
						case 'day':
							start = new Date(start.getFullYear(), start.getMonth(), start.getDate() + 1, start.getHours(), start.getMinutes(),
								start.getSeconds())
							break
						case 'week':
							start = new Date(start.getFullYear(), start.getMonth(), start.getDate() + 7, start.getHours(), start.getMinutes(),
								start.getSeconds())
							break
						case 'month':
							var lastDate = start.getDate()
							var nDate = new Date(start.getFullYear(), start.getMonth() + 1, start.getDate(), start.getHours(), start.getMinutes(),
								start.getSeconds())
							if(lastDate != nDate.getDate()) {
								start = new Date(start.getFullYear(), start.getMonth() + 2, start.getDate(), start.getHours(), start.getMinutes(),
									start.getSeconds())
								list.push(start.formatByTime('-'))
								continue
							}
							start = nDate
							break
						case 'year':
							start = new Date(start.getFullYear() + 1, start.getMonth(), start.getDate(), start.getHours(), start.getMinutes(),
								start.getSeconds())
							break
					}
					list.push(start.formatByTime('-'))
				}
				list.push("...")
				return list
			}
		},
		watch: {
			nowFlowTree(nv, ov) {
				//加载在watch只是为了让它更快计算
			},
			userTree(nv, ov) {

			},
			orderGroupList(nv, ov) {
				this.nowOrderGroup = nv[0]
				this.nowOrderGroupnew = nv[0].id
			},
			flowTree(nv, ov) {},
			radio(val){
				if(val == "1"){
					this.isCycle = false
				}else {
					this.isCycle = true
				}
			}
		},
		methods: {
			//返回列表
			returnToList(){
            //    console.log("子组件");
			   this.$emit('returnToList',0);
			},
			addUsers() {
				this.$dialogMethod.openMultipleSelectionDialog('抄送人', this.userTree, this.participants.map(item => item.userId),
					respon => {
						//一次可以添加多个
						this.participants = respon
					})
			},
			upload(orderType, cycleType) {
				if(isempty(this.orderTitle)) {
					this.$dialogMethod.showMessage("工单标题不能为空!")
					return
				}
				var nodes = this.$refs.createNodeBean.getData()
					// archivesIdsFun
				var archivesIdsId = this.$refs.createNodeBean.archivesIdsFun()
				console.log("发布nodes",nodes);
				// console.log("发布archivesIdsId",archivesIdsId);

				let archivesIds = []

				if(nodes.length == 0) {
					this.$dialogMethod.showMessage("至少需要具有一个节点!")
					return
				}
				//var actionList = this.$refs.createNodeBean.actionList
				for(var i = 0, len = nodes.length; i < len; i++) {
					
					
					if(nodes[i].nodeType == 2) {
						if(nodes[i].next.length != 0){
                           archivesIds = nodes[i].next.map(item => {
							return item.linkObject
							}).join(",")
						}else {
							
							archivesIds = nodes[i].archivesIds
							
						}
				        	nodes[i].archivesIds = copy(archivesIds)
						
					}
					if(isempty(nodes[i].nodeUsers)) {
						this.$dialogMethod.showMessage(`${nodes[i].nodeName} 节点必须有负责人!`)
						return
					}
					// console.log("nodes[i].next",nodes[i].next);
					// console.log("nodes[i].archivesIds",nodes[i].archivesIds);
					// console.log("nodes[i].nodeType == 2",nodes[i].nodeType == 2);
					if(isempty(nodes[i].next) && isempty(nodes[i].archivesIds) && nodes[i].nodeType == 2) {
						// console.log("不符合条件",nodes[i]);
						this.$dialogMethod.showMessage(`${nodes[i].nodeName} 的节点类型为“巡检”时必须选择台账设备!`)
						return
					}
					/* if(isempty(actionList) && nodes[i].nodeType == 0) {
						this.$dialogMethod.showMessage("操作项至少需要有一个操作步骤!")
						return
					} */
					for(var i1 = 0, len1 = nodes[i].next.length; i1 < len1; i1++) {
						var item = nodes[i].next[i1]
						if(isempty(item.next) && nodes[i].nodeType == 0) {
							this.$dialogMethod.showMessage(`${nodes[i].nodeName} 操作项至少需要有一个操作步骤!`)
							return
						}
					}
				}
				// console.log("最终nodes",nodes);
				
				var workTime = this.orderEndTime.getTime() - this.orderStartTime.getTime()
				// var workTime = this.orderEndTime.getTime()
				if(workTime <= 0) {
					this.$dialogMethod.showMessage("截至时间不能早于开始时间!")
					return
				} else if(this.orderEndTime.getTime() < new Date().getTime() + 30 * 60 * 1000) {
					this.$dialogMethod.showMessage("截至时间必须在30分钟后!")
					return
				}
				this.$dialogMethod.showLoading('正在发布');
				this.$api.orderApi.addOrder(this.nowOrderGroup.groupId, orderType, this.orderTitle,
					this.orderContent, this.orderStartTime.getTime(), workTime,
					undefined, cycleType,
					nodes,
					//participants
					this.participants.filter(item => {
						return item != undefined
					}).map(item => item.userId).join(',')
					,respon => {
						this.$dialogMethod.showMessage('发布成功!')
						 this.$emit('returnToList',respon.orderId);

						this.$dialogMethod.closeLoading()
					})
			},
			pickerOrderGroup() {
				// console.log("this.orderGroupList",this.orderGroupList);
				// console.log("this.nowOrderGroup",this.nowOrderGroup);
				this.$dialogMethod.openSingleItemDialog('选择工单分组', this.orderGroupList, this.nowOrderGroup == undefined ?
					undefined : [this.nowOrderGroup.id],
					respon => {
						this.nowOrderGroup = respon[0]
					})
			},
			pickerOrderGroup_fn(val){
				var arr = this.orderGroupList.filter(item => item.id == val)
				this.nowOrderGroup = arr[0]
				// this.nowOrderGroup = respon[0]
			},
			pickerWorkFlow() {
				this.$dialogMethod.openSingleItemDialog('选择工作流', this.flowTree, this.nowInputFlow == undefined ?
					undefined : this.nowInputFlow.id,
					respon => {
						this.nowInputFlow = respon[0]
						
						if(this.nowInputFlow == undefined) {
							this.$dialogMethod.showMessage('未选中工作流!')
							return
						}
						//获取工作流并且加载和提示
						this.$dialogMethod.openAgreeDialog('导入工作流', '将会覆盖当前工作流，是否继续?', respon => {
							if(this.nowFlowTree == undefined) {
								this.$dialogMethod.showMessage('当前选中工作流信息还在获取中，请稍后重试！')
							} else {
								//加载
								this.nowOrderGroupnew =  this.nowInputFlow.groupId + ''
								this.$set(this.nowFlow, 'next', copy(this.nowFlowTree.next))
							}
						})
					})
			},
			isFromEvent(){
				if (this.$store.cacheStore.state.eventToOrderCache != undefined) {
					var eventBean = this.$store.cacheStore.state.eventToOrderCache
					this.$store.cacheStore.state.eventToOrderCache = undefined
					//类型指定为抢修
					if(this.orderGroupList != undefined) {
						this.nowOrderGroup = this.orderGroupList.find(item=>item.id == 3)
					}
					//描述里面写事件内容
					this.orderContent = '告警对象:【{0}】,事件等级:【{1}】,内容:【{2}】,产生时间:【{3}】'.format(eventBean.linkobject,eventBean.levelName,eventBean.description,new Date(eventBean.time).formatByTime())
				}
			}
		}
	}
</script>

<style scoped lang="scss">
	.orderBody {
		display: flex;
		justify-content: space-between;
		color: black;
		background: white;
	}
	
	.leftPart {
		width: 200px;
		display: flex;
		// align-items: center;
		justify-content: flex-start;
		flex-direction: column;
		/* border: silver 1px solid; */
		margin: 10px 0px 0px 20px;
		border-radius: 5px;
		/deep/.el-input__inner {
		width: 200px;
		height: 32px;
		color: #1a1a1a;

			}
			/deep/.el-input__icon {
				line-height: 32px;
			}
			/deep/.el-input__suffix {
				right:25px
			}
	}
	.title-top {
		margin-top: 20px !important;
	}
	
	.leftPart>p,
	.rightPart>p {
		width: 178px;
		margin: 0.03rem 0;
		color: #999;
		    font-size: 14px;
	}
	
	.pickerText {
		color: #1a1a1a !important;
		border: 1px solid #DCDFE6 !important;
	}
	
	.buttonP {
		cursor: pointer;
		background: #DA7800;
		color: white;
		padding: .1rem;
		border: 1px solid #DCDFE6 ;
		text-align: center;
		border-radius: 10px;
		margin-top: 10px;
	}
	
	.buttonP:hover,
	.saveToDemo:hover,
	.saveToDemo>p:hover {
		background: #Ca7800;
	}
	
	.uploadDiv {
		width: 160px;
		margin-top: .1rem;
	}
	.rightPart {
		width: calc(100% - 200px);
		border-left: #E6E6E6 1px solid;
		margin: 10px;
		margin-right: 20px;
		// border-radius: 5px;
		.right-top {
			display: flex;
			align-items: center;
			justify-content: space-between;
			margin-top: 24px;
			margin-left: 10px;
			border-bottom: 1px solid #E6E6E6;
			padding-bottom: 20px;
			.flex-left {
				display: flex;
				align-items: center;
				width: 75%;
				
					.top-mome {
						display: flex;
						width: 50%;
						align-items: center;
						/deep/.el-input {
							width: 3.6rem;
							height: 32px;
						}
						/deep/.el-input__inner {
							height: 32px;
						}
						/deep/.el-textarea{
						width: 4rem;
						}
						/deep/.el-textarea__inner {
							height: 32px !important;
						}
					}
			}
			
		}
	}
	
	.uploadDiv>p {
		margin: 0;
		width: 120px;
		border-radius: 10px 0 0 10px;
	}
	
	.saveToDemo {
		width: 40px;
		height: 100%;
		background: #DA7800;
		border-radius: 0 10px 10px 0;
		border: white .01rem solid;
		border-left: 0;
		cursor: pointer;
		position: relative;
	}
	
	.saveToDemo>p {
		position: absolute;
		background: #DA7800;
		width: 100px;
		left: -85px;
		padding: .1rem;
		border-radius: 10px;
		border: white .01rem solid;
		color: white;
	}
	
	
	
	.participants {
		width: 130px !important;
	}
	
	.tabP {
		width: 50%;
		text-align: center;
		border-bottom: #000000 dashed 1px;
		padding: 5px 0 10px 0;
		cursor: pointer;
	}
	
	.tabP:first-child,
	.inputButtonP:first-child {
		border-right: #000000 dashed 1px;
	}
	
	.tabP:first-child {
		border-radius: 20px 0 0 0;
	}
	
	.tabP:last-child {
		border-radius: 0 20px 0 0;
	}
	
	.tabP.isCheck {
		background: #DA7800;
		color: white;
	}
	
	.inputButtonP {
		width: 50%;
		text-align: center;
		border-top: #000000 dashed 1px;
		padding: 10px 0 5px 0;
		cursor: pointer;
	}
	
	.inputButtonP:hover {
		color: #DA7800;
	}
	
	.leftPart>p.pickerText {
		margin-top: 0;
	}
	
	.pickerBody {
		width: 160px;
	}
	
	/deep/.el-radio {
		margin-right: 20px;
		margin-top: 3px;
	}
	.cycleTime {
		border: 1px solid #DCDFE6 ;
		width: 160px;
		border-radius: 5px;
		overflow: hidden;
	}
	
	.cycleType>p {
		text-align: center;
		width: calc((100% - 1px)/2);
		padding: 5px;
		cursor: pointer;
		
	}
	
	.cycleType>p:first-child {
		border-right: silver dashed 1px;
	}
	
	.cycleType>p:hover,
	.cycleType>p.isCheck,
	.cycleTime>p:hover,
	.cycleTime>p.isCheck {
		background: #409EFF;
		color: white;
	}
	
	.cycleTime>p {
		width: calc((100% - 3px)/4);
		text-align: center;
		// border-right: silver 1px dashed;
		border-right: 1px solid #DCDFE6;
		cursor: pointer;
		color: #999;
		padding: 5px 0;
		
	}
	
	.cycleTime>p:last-child {
		border: 0;
	}
</style>